import { render, staticRenderFns } from "./list_duplicate.html?vue&type=template&id=70095b42&scoped=true&"
import script from "./list_duplicate.js?vue&type=script&lang=js&"
export * from "./list_duplicate.js?vue&type=script&lang=js&"
import style0 from "./list_duplicate.scss?vue&type=style&index=0&id=70095b42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70095b42",
  null
  
)

export default component.exports